import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CreateUpdateBrandEntity } from '../../domain/entities/CreateUpdateBrandEntity'

export class CreateUpdateBrandModel extends CreateUpdateBrandEntity {
  translations = []
  constructor(dataDto: CreateUpdateBrandEntity) {
    super()
    mapEntityProperties<CreateUpdateBrandModel>(this, dataDto)
  }
}
